import * as ActionTypes from '../actions/types/DashboardActionTypes';

const initialState = {
  busy: true,
  wedding_website_feature: {},
  registry_feature: {},
  checklist_feature: {},
  guestlist_feature: {},
  days_til_wedding: -1
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_DASHBOARD: {
      return Object.assign({}, state, { busy: true });
    }
    case ActionTypes.RECEIVE_DASHBOARD: {
      return Object.assign(
        {},
        state,
        action.payload,
        { busy: false }
      );
    }
    default: return state;
  }
};

export default dashboardReducer;



/** WEBPACK FOOTER **
 ** ./src/reducers/dashboard.js
 **/